/**
 * @Author: abbeymart | Abi Akindele | @Created: 2019-04-03 | @Updated: 2020-07-04
 * @Company: mConnect.biz | @License: MIT
 * @Description: mc-web routes
 */

import { commonRoutes } from './commonRoutes';
import { userRoutes } from './userRoutes';
import { groupRoutes } from './groupRoutes';
import { appRoutes } from './appRoutes';
import { serviceRoutes } from './serviceRoutes';
import { contentRoutes } from './contentRoutes';
import { settingRoutes } from './settingRoutes';
import { auditRoutes } from 'src/router/central/auditRoutes';
import { bookmarkRoutes } from 'src/router/central/bookmarkRoutes';
import { contactRoutes } from 'src/router/central/contactRoutes';
import { locationRoutes } from 'src/router/central/locationRoutes';
import { localeRoutes } from 'src/router/central/localeRoutes';
import { orgRoutes } from 'src/router/central/orgRoutes';
import { docRoutes } from 'src/router/central/docRoutes';
import { taxRoutes } from 'src/router/central/taxRoutes';
import { payRoutes } from 'src/router/central/payRoutes';
import { folderRoutes } from 'src/router/central/folderRoutes';
import { qaRoutes } from 'src/router/central/qaRoutes';

export const centralRoutes = [
  ...appRoutes,
  ...commonRoutes,
  ...userRoutes,
  ...contentRoutes,
  ...settingRoutes,
  ...serviceRoutes,
  ...groupRoutes,
  ...auditRoutes,
  ...bookmarkRoutes,
  ...contactRoutes,
  ...locationRoutes,
  ...localeRoutes,
  ...orgRoutes,
  ...docRoutes,
  ...taxRoutes,
  ...payRoutes,
  ...folderRoutes,
  ...qaRoutes,
];
